<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ activeUserInfo.userRole }}</small>
    </div>
    <div class="con-img ml-3">
      <img
        v-if="activeUserInfo.photoURL"
        key="onlineImg"
        :src="activeUserInfo.photoURL"
        alt="user-img"
        width="40"
        height="40"
        class="rounded-full shadow-md block"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/pages/logout').catch(() => {})
    }
  }
}
</script>
